export const exomeId: unique symbol = Symbol();
export const exomeName: unique symbol = Symbol();
export const FUNCTION = "function";
export const CONSTRUCTOR = "constructor";
